import { Grid } from '@mui/material';
import { RoutalDialog, RoutalSelect, RoutalSelectMultiSelectOption, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { PlanFlat } from '../domain/plan/PlanFlat';
import { PlanStatus } from '../domain/plan/PlanStatus';
import { useUpdateFlatPlansStatus } from '../hooks/plan/useUpdateFlatPlansStatus';

import Button from '../react-components/Button';
import Text from '../react-components/Text';

type PlanStatusDialogProps = {
  plans: Array<PlanFlat>;
  dialogOpen: boolean;
  onUpdatePlanStatus: () => void;
  onCloseDialog: () => any;
};

export const PlanStatusDialog = ({ plans, dialogOpen, onUpdatePlanStatus, onCloseDialog }: PlanStatusDialogProps) => {
  const [updateStatus, setUpdateStatus] = useState<PlanStatus | undefined>(undefined);
  const { success: updateSuccess, isLoading: isUpdatingStatus, run: updatePlansStatus } = useUpdateFlatPlansStatus();

  useEffect(() => {
    if (updateSuccess) {
      onUpdatePlanStatus();
      onCloseDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateSuccess]);

  return (
    <RoutalDialog
      open={dialogOpen}
      onCloseDialog={onCloseDialog}
      titleContent={<Text variant="h6" intlId="update_plan_status_dialog.title" />}
      titleRightContent={
        <Button
          id="change_status"
          styleType="primary"
          onClick={() => {
            if (updateStatus && !isUpdatingStatus) {
              updatePlansStatus({ flatPlans: plans, status: updateStatus });
            }
          }}
          intlId="update_plan_status_dialog.button"
        />
      }
      showFooter={false}
    >
      <RoutalSelect
        id="select-status"
        style={{
          width: `350px`,
        }}
        popoverProps={{
          options: [`in_progress`, `planning`, `finished`, `draft`].map(
            (status): RoutalSelectMultiSelectOption => ({
              key: status,
              onClick: () => {
                setUpdateStatus(status as PlanStatus);
              },
              content: (
                <Grid container direction="row" wrap="nowrap" alignItems="center" style={{ overflow: `hidden` }}>
                  <Text
                    tagName="span"
                    style={{
                      textAlign: `justify`,
                      whiteSpace: `nowrap`,
                      overflow: `hidden`,
                      width: `100%`,
                      textOverflow: `ellipsis`,
                      cursor: `pointer`,
                    }}
                    intlId={`update_plan_status_dialog.status.${status}`}
                  />
                </Grid>
              ),
            })
          ),
        }}
      >
        <Text
          style={{
            cursor: `pointer`,
            width: `100%`,
            textAlign: `justify`,
          }}
          intlId={
            updateStatus
              ? `update_plan_status_dialog.status.${updateStatus}`
              : `update_plan_status_dialog.select_status`
          }
        />
      </RoutalSelect>
      <VSpacer medium />
    </RoutalDialog>
  );
};
